module.exports = __webpack_public_path__ + "static/remove_access_form-60b2051d504b277d53251064e3966225.png";